<template lang="pug">
.position-relative
  .navigation
    .position-back
      .button.is-small(
        @click="$emit('prev')"
      )
        span.icon.is-small
          i.fa.fa-arrow-left
        span Previous step
  .step-title
    span Select your coin or token

  .control.is-medium.is-expanded.mt-20
    input.input.is-medium#local-coin-search(
      type="text" 
      placeholder='Search for your coin / token', 
      v-model='filter'
      ref='inputcoin'
    )
  br
  template(v-if="isLoading")
    span Loading...
    br
  .column
    .columns.is-multiline.is-mobile
      .column.box-container.is-half-desktop.is-full-tablet.is-full-mobile(
        v-for="o in firstList"
      )
        .element-box-container(href="#", @click="select(o)")
          strong.tag.hint--bottom.top(
            aria-label='Just added'
            v-if="o.top == 1"
          ) New
          img(:src="o.logo", :alt="o.symbol + ' icon'")
          div
            .flex-1.has-text-left
              span.name
                b {{ o.name }} 
              span.symbol ({{ o.symbol}})
            .extra-info.has-text-left(v-if="o.chains.length > 0")
              .tag.network.hint--bottom.hint--medium(
                :aria-label="'Supported through the ' + u.name + ' (' + u.network + ') network'"
                v-for="u in o.chains"
                v-if="o.chains.length > 0"
              ) {{ u.token_standard || u.network }}
      .column.box-container.is-half-desktop.is-full-tablet.is-full-mobile(
        v-for="o in shadowList"
      )
        .element-box-container(href="#", @click="select(o)")
          strong.tag.hint--bottom.top(
            aria-label='Just added'
            v-if="o.top == 1"
          ) New
          img(:src="o.logo", :alt="o.symbol + ' icon'")
          div
            .flex-1.has-text-left
              span.name
                b {{ o.name }} 
              span.symbol ({{ o.symbol}})
            .extra-info.has-text-left(v-if="o.chains.length > 0")
              .tag.network.hint--bottom.hint--medium(
                :aria-label="'Supported through the ' + u.name + ' (' + u.network + ') network'"
                v-for="u in o.chains"
                v-if="o.chains.length > 0"
              ) {{ u.token_standard || u.network }}

</template>

<script>
export default {
  name: 'c_step_coin',
  data () {
    return {
      isLoading: true,
      filter: ''
    }
  },
  computed: {
    lastCoinsSelected () {
      return this.$store.getters.lastCoins
    },
    coins () {
      return this.$store.getters.coins
    },
    firstList () {
      var vm = this
      let filtered = []

      if (vm.filter) {
        filtered = vm.coins.filter(o =>
          vm.lastCoinsSelected.indexOf(o.symbol) > -1 && (o.name.toUpperCase().includes(vm.filter.toUpperCase()) || o.symbol.toUpperCase().includes(vm.filter.toUpperCase()) || o.network.toUpperCase().includes(vm.filter.toUpperCase()))
        )
      } else {
        filtered = vm.coins.filter(o =>
          vm.lastCoinsSelected.indexOf(o.symbol) > -1
        )
      }

      // Order by lastCoinsSelected
      let filterOrdered = []
      for (var i = 0; i < vm.lastCoinsSelected.length; i++) {
        for (var j = 0; j < filtered.length; j++) {
          if (vm.lastCoinsSelected[i] === filtered[j].symbol) {
            filterOrdered.push(filtered[j])
          }
        }
      }

      return filterOrdered
    },
    shadowList () {
      var vm = this
      if (vm.filter) {
        return vm.coins.filter(o =>
          vm.lastCoinsSelected.indexOf(o.symbol) === -1 && (o.name.toUpperCase().includes(vm.filter.toUpperCase()) || o.symbol.toUpperCase().includes(vm.filter.toUpperCase()) || o.network.toUpperCase().includes(vm.filter.toUpperCase()))
        )
      } else {
        return vm.coins.filter(o =>
          vm.lastCoinsSelected.indexOf(o.symbol) === -1
        )
      }
    }
  },
  async created () {
    let vm = this
    if (!(vm.$store.getters.coins && vm.$store.getters.coins.length > 0)) {
      await vm.$store.dispatch('getCoins')
      vm.isLoading = false
    } else {
      vm.isLoading = false
    }
  },
  mounted () {
    let vm = this
    if (window && window.innerWidth > 500) {
      vm.$refs.inputcoin.focus()
    }
    document.getElementById('step').scrollIntoView();
  },
  methods : {
    select (coin) {
      let vm = this
      vm.$store.dispatch('addToCoinList', coin.symbol)
      vm.$emit('selected', coin)
    },
    chainsText (chains) {
      let text = []
      for (var i = 0; i < chains.length; i++) {
        let u = chains[i]
        text.push(u.name + ' (' + u.network + ') network')
      }
      return text.join(', ')
    }
  }
}
</script>

<style lang="stylus" scoped>
.gs 
  .columns
    margin-left: -1.1rem;
    margin-right: -1.1rem;
    margin-top: -1.1rem;
  .box-container
    margin-top 0px
    padding 5.5px 5px
    .element-box-container
      display flex
      position relative
      margin 0
      align-items center
      padding 15px
      img
        margin 0px 10px 0px 0px
        width: 40px;
        height: 40px;
        border-radius 5px
      .top
        background-color: #b6ffb6;
        display block
        position absolute
        top 0px
        right -0.5px
        line-height: 20px;
        height: 20px;
        border-radius 0px
        border-top-right-radius 4px
        font-size 10px
      .bottom
        position absolute
        bottom 0px
        left 0px
        width 100%
      .symbol
        font-size 14px
      .tag.network
        margin-right: 3px;
        background: #ffffff;
        color: #000;
        padding: 0px 5px;
        font-weight: 500;
        font-size: 9px;
        display: inline-block;
        border-radius: 0px;
        line-height: 18px;
        border-radius: 2px;
        border: solid 1px #ccc;
</style>



// WEBPACK FOOTER //
// c_step_coin.vue?ad371784